import { useState } from 'react';
import { useReduxState } from 'hooks';
import { useApiData } from 'lib/api';
import { ApiDownloadButton, Badge, LoadingIndicator } from 'components/common';

interface Props {
  isSharedConfigured?: boolean;
  requireAuthentication?: boolean;
}

const TwoFactorBackupCodes = ({
  isSharedConfigured,
  requireAuthentication = true
}: Props) => {
  const { messages, serverConfig } = useReduxState();

  const [authenticated, setAuthenticated] = useState(
    true || isSharedConfigured || !requireAuthentication
  ); // remove the true when authentication requirements are implemented

  const { data, loading } = useApiData({
    url:
      `/auth/totp/backup-codes` +
      `${isSharedConfigured ? '?isSharedConfigured=true' : ''}`,
    onlyIf: authenticated // TODO: implement authentication requirements
  });

  return loading ? (
    <LoadingIndicator />
  ) : authenticated ? (
    <div className="backup-codes">
      <div className="backup-codes-info">
        {messages.authTwoFactorBackupCodesInfo}
      </div>

      <div className="backup-codes-content">
        {data?.backupCodes && data?.backupCodes.length
          ? data?.backupCodes.map((code) => (
              <div className="backup-codes-code" key={code}>
                <Badge isRounded={false} text={code} />
              </div>
            ))
          : null}
      </div>

      <div className="backup-codes-download">
        <ApiDownloadButton
          category="light"
          filename={`${serverConfig.hostname}-backup-codes.txt`}
          icon={['far', 'file-alt']}
          text={messages.authTwoFactorDownloadCodes}
          url={
            `/auth/totp/backup-codes-download` +
            `${isSharedConfigured ? '?isSharedConfigured=true' : ''}`
          }
        />
      </div>

      <style jsx>{`
        .backup-codes-content {
          display: flex;
          flex-wrap: wrap;
          margin-top: 15px;
          max-width: 200px;
        }
        .backup-codes-code {
          padding: 0 10px 10px 0;
          width: 50%;
        }
        .backup-codes-download {
          margin-top: 10px;
        }
      `}</style>
    </div>
  ) : null;
};

export default TwoFactorBackupCodes;
